// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  width: 100%;
  height: calc(1.5em + 1.12rem + 2px);
  padding: 0.56rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background: #eaeaf9;
  border-radius: 0.25rem;
  border: 1px solid #e5e9f2;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}

.form-control:focus {
  outline: 1px solid #e5e9f2;
}

.sign-block {
  margin-inline: 150px;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,wEAAwE;EACxE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":[".form-control {\n  width: 100%;\n  height: calc(1.5em + 1.12rem + 2px);\n  padding: 0.56rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background: #eaeaf9;\n  border-radius: 0.25rem;\n  border: 1px solid #e5e9f2;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  outline: none;\n}\n\n.form-control:focus {\n  outline: 1px solid #e5e9f2;\n}\n\n.sign-block {\n  margin-inline: 150px;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
